import router, { constantRoutes, asyncRoutes } from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import { Message } from 'element-ui'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login']

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/', replace: true })
      NProgress.done()
      return
    }
    const hasRoles = store.getters.roles && store.getters.roles.length > 0
    const routesAdded = store.getters.addRoutes && store.getters.addRoutes.length > 0
    if (hasRoles && routesAdded) {
      next()
    } else {
      try {
        if (!hasRoles) {
          await store.dispatch('user/getInfo')
        }
        if (!routesAdded) {
          const accessRoutes = filterAsyncRoutes(asyncRoutes, store.getters.permissions)
          router.addRoutes(accessRoutes)
          await store.dispatch('permission/generateRoutes', accessRoutes)
        }
        next({ ...to, replace: true })
      } catch (error) {
        await store.dispatch('user/resetToken')
        Message.error(error.message || '获取用户信息失败')
        next(`/login?redirect=${to.path}`)
        NProgress.done()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})

function filterAsyncRoutes(routes, permissions) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(permissions, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, permissions)
      }
      if (!tmp.children || tmp.children.length > 0 || !tmp.meta) {
        res.push(tmp)
      }
    }
  })
  return res
}

function hasPermission(permissions, route) {
  if (store.getters.roles.includes('super_admin')) return true
  if (route.meta && route.meta.permission) {
    return permissions.includes(route.meta.permission)
  }
  return true
}
